export const categories = [
  { id: 1, slug: 'romance', name: '恋爱言情', icon: 'ri-heart-line', description: '浪漫甜蜜的韩漫恋爱故事，从校园到职场，甜到心动' },
  { id: 2, slug: 'action', name: '热血动作', icon: 'ri-fire-line', description: '劲爆战斗场面，超燃动作韩漫，每一页都是视觉盛宴' },
  { id: 3, slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '穿越异世界，魔法与剑的奇幻韩漫冒险之旅' },
  { id: 4, slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的韩漫日常，笑到停不下来的欢乐时光' },
  { id: 5, slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '扣人心弦的悬疑韩漫，反转再反转，烧脑不停' },
  { id: 6, slug: 'drama', name: '都市剧情', icon: 'ri-building-line', description: '真实感人的都市韩漫，描绘现代人的喜怒哀乐' },
  { id: 7, slug: 'bl', name: 'BL专区', icon: 'ri-moon-line', description: '高人气BL韩漫专区，甜蜜又带感的故事' },
  { id: 8, slug: 'completed', name: '已完结', icon: 'ri-check-double-line', description: '已经完结的经典韩漫，一口气看到结尾' },
];

export const comics = [
  {
    id: 1,
    title: '女神降临',
    slug: 'goddess-descent',
    category: 'romance',
    author: 'Yaongyi',
    description: '因为外貌被欺负的女孩，通过化妆术逆袭成为校园女神，却陷入三角恋的甜蜜烦恼中。',
    longDescription: '任晶晶因为长相平凡，在学校里一直是被嘲笑的对象。转学后她决定通过精湛的化妆技术改变自己，一夜之间成为了校园里的"女神"。然而在光鲜亮丽的外表下，她始终担心真实的自己被揭穿。当她遇到了两个性格迥异的男生——一个是阳光帅气的校草李修豪，另一个是冷酷神秘的前辈韩书俊，她的生活变得更加复杂而精彩。',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20girl%20with%20flawless%20makeup%20holding%20a%20mirror%20in%20front%20of%20vanity%20desk%20soft%20pink%20and%20white%20tones%20romantic%20atmosphere%20editorial%20photography%20style%20clean%20background&width=800&height=900&seq=comic-01-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20girl%20with%20flawless%20makeup%20holding%20a%20mirror%20in%20front%20of%20vanity%20desk%20soft%20pink%20and%20white%20tones%20romantic%20atmosphere%20editorial%20photography%20style%20clean%20background&width=800&height=400&seq=comic-01-banner&orientation=landscape',
    chapters: 256,
    status: '连载中',
    rating: 9.5,
    views: '3.2亿',
    tags: ['恋爱', '校园', '逆袭', '甜宠'],
    featured: true,
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'solo-leveling',
    category: 'action',
    author: 'Chugong',
    description: '被称为人类最弱兵器的少年，在濒死之际获得神秘系统，开启了逆天升级之路。',
    longDescription: '在一个次元门连接异世界的地球上，觉醒了特殊能力的人类被称为"猎人"。成振宇是E级猎人，被誉为"人类最弱兵器"。在一次几乎全员覆没的双重地下城任务中，他濒死之际意外获得了神秘的"系统"，从此拥有了无限升级的能力。随着实力飞速提升，他逐渐揭开了次元门背后的真相，踏上了一条前所未有的强者之路。',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20powerful%20warrior%20with%20glowing%20blue%20eyes%20and%20energy%20aura%20standing%20in%20ruined%20city%20scene%20dramatic%20cinematic%20lighting%20intense%20atmosphere%20cool%20blue%20and%20black%20tones&width=800&height=900&seq=comic-02-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20powerful%20warrior%20with%20glowing%20blue%20eyes%20and%20energy%20aura%20standing%20in%20ruined%20city%20scene%20dramatic%20cinematic%20lighting%20intense%20atmosphere%20cool%20blue%20and%20black%20tones&width=800&height=400&seq=comic-02-banner&orientation=landscape',
    chapters: 179,
    status: '已完结',
    rating: 9.8,
    views: '8.5亿',
    tags: ['热血', '升级', '战斗', '系统'],
    featured: true,
  },
  {
    id: 3,
    title: '某天成为公主',
    slug: 'became-princess',
    category: 'fantasy',
    author: 'Spoon',
    description: '穿越成小说中注定死亡的公主，为了活下来而努力获得冷酷父皇宠爱的故事。',
    longDescription: '女主角在一次意外后穿越到了自己读过的小说世界中，成为了那位注定被亲生父亲——冷血皇帝处死的公主希娅。为了改变自己悲惨的命运，她决定主动接近这位冷酷无情的父亲，试图获得他的宠爱。在这个过程中，她不仅逐渐融化了父皇冰封的心，还意外地改变了整个帝国的命运走向。',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20princess%20in%20elegant%20flowing%20pink%20gown%20with%20golden%20crown%20standing%20in%20palace%20garden%20cherry%20blossoms%20falling%20soft%20dreamy%20lighting%20fairytale%20aesthetic%20pastel%20tones%20clean%20elegant%20composition&width=800&height=900&seq=comic-03-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20princess%20in%20elegant%20flowing%20pink%20gown%20with%20golden%20crown%20standing%20in%20palace%20garden%20cherry%20blossoms%20falling%20soft%20dreamy%20lighting%20fairytale%20aesthetic%20pastel%20tones%20clean%20elegant%20composition&width=800&height=400&seq=comic-03-banner&orientation=landscape',
    chapters: 198,
    status: '连载中',
    rating: 9.6,
    views: '5.1亿',
    tags: ['穿越', '宫廷', '治愈', '父女'],
    featured: true,
  },
  {
    id: 4,
    title: '奶酪陷阱',
    slug: 'cheese-trap',
    category: 'drama',
    author: 'Soonkki',
    description: '平凡女大学生与表面上完美的学长之间，充满疑惑与吸引力的大学校园故事。',
    longDescription: '洪雪是一个努力刻苦的普通女大学生，好不容易回到学校继续学业，却遇到了看似完美的学长刘正。刘正在所有人眼中都是无可挑剔的完美人物，但洪雪却隐约感觉到他笑容背后隐藏的冷漠与心机。随着两人关系的深入，一段充满微妙心理博弈和复杂情感的大学校园故事由此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20Korean%20university%20students%20walking%20side%20by%20side%20on%20autumn%20campus%20path%20fallen%20leaves%20warm%20golden%20afternoon%20light%20soft%20romantic%20atmosphere%20warm%20beige%20and%20brown%20tones%20editorial%20style%20photography&width=800&height=900&seq=comic-04-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Two%20Korean%20university%20students%20walking%20side%20by%20side%20on%20autumn%20campus%20path%20fallen%20leaves%20warm%20golden%20afternoon%20light%20soft%20romantic%20atmosphere%20warm%20beige%20and%20brown%20tones%20editorial%20style%20photography&width=800&height=400&seq=comic-04-banner&orientation=landscape',
    chapters: 301,
    status: '已完结',
    rating: 9.3,
    views: '4.8亿',
    tags: ['校园', '心理', '恋爱', '现实'],
    featured: false,
  },
  {
    id: 5,
    title: '大贵族',
    slug: 'noblesse',
    category: 'action',
    author: 'Son Jeho',
    description: '沉睡了820年的贵族吸血鬼苏醒后，在现代社会中与朋友们展开的奇幻战斗故事。',
    longDescription: '卡迪斯·艾特拉马·迪·莱杰罗（莱），是一名沉睡了820年的贵族吸血鬼。苏醒后的他进入了现代人类社会，在一所高中就读。他沉默寡言但实力超群，默默守护着身边的人类朋友。然而，随着神秘组织的出现和过往宿敌的追踪，莱的真实身份逐渐暴露，一场关乎人类与贵族存亡的大战即将爆发。',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20silver-haired%20vampire%20noble%20in%20dark%20formal%20suit%20standing%20dramatically%20on%20modern%20city%20rooftop%20at%20night%20moon%20behind%20him%20crimson%20eyes%20gothic%20aesthetic%20dark%20navy%20and%20crimson%20tones%20cinematic%20composition&width=800&height=900&seq=comic-05-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Elegant%20silver-haired%20vampire%20noble%20in%20dark%20formal%20suit%20standing%20dramatically%20on%20modern%20city%20rooftop%20at%20night%20moon%20behind%20him%20crimson%20eyes%20gothic%20aesthetic%20dark%20navy%20and%20crimson%20tones%20cinematic%20composition&width=800&height=400&seq=comic-05-banner&orientation=landscape',
    chapters: 544,
    status: '已完结',
    rating: 9.4,
    views: '6.3亿',
    tags: ['吸血鬼', '战斗', '校园', '奇幻'],
    featured: false,
  },
  {
    id: 6,
    title: '外貌至上主义',
    slug: 'lookism',
    category: 'drama',
    author: 'Park Taejun',
    description: '肥胖少年突然拥有了两具身体——白天是完美帅哥，夜晚变回原本的自己。',
    longDescription: '丹尼尔是一个因为肥胖外貌而饱受欺凌的高中生，在转学到首尔后，某天醒来发现自己拥有了两具身体：一具是原本肥胖的自己，另一具则是高大帅气的完美男神身材。白天他用帅气身体生活，晚上则变回原样。随着两个身份的交替，他逐渐看透了人们对不同外貌的态度差异，也慢慢学会了接纳真正的自己。',
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20contrast%20between%20an%20overweight%20teenager%20and%20his%20handsome%20alter%20ego%20side%20by%20side%20urban%20Seoul%20street%20background%20dramatic%20lighting%20modern%20Korean%20high%20school%20aesthetic&width=800&height=900&seq=comic-06-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20contrast%20between%20an%20overweight%20teenager%20and%20his%20handsome%20alter%20ego%20side%20by%20side%20urban%20Seoul%20street%20background%20dramatic%20lighting%20modern%20Korean%20high%20school%20aesthetic&width=800&height=400&seq=comic-06-banner&orientation=landscape',
    chapters: 450,
    status: '连载中',
    rating: 9.2,
    views: '7.1亿',
    tags: ['校园', '社会', '成长', '双身'],
    featured: false,
  },
  {
    id: 7,
    title: '看脸时代',
    slug: 'face-era',
    category: 'comedy',
    author: 'Park Taejun',
    description: '丑陋的男生通过神秘力量变成帅哥，在两个身份之间过着双面人生的爆笑故事。',
    longDescription: '这个超人气韩漫以幽默和深刻的视角探讨了外貌在社会中的重要性。主角在两个截然不同的身体之间切换，体验着世界的巨大反差——丑陋时被无视甚至欺凌，帅气时却受到各种优待。这种极端的对比不仅带来了无数搞笑场景，也引发了对社会现实的深刻思考。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20comedy%20scene%20with%20exaggerated%20funny%20expressions%20two%20contrasting%20characters%20one%20handsome%20one%20ordinary%20in%20school%20hallway%20bright%20colorful%20manga-inspired%20style%20playful%20atmosphere&width=800&height=900&seq=comic-07-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20comedy%20scene%20with%20exaggerated%20funny%20expressions%20two%20contrasting%20characters%20one%20handsome%20one%20ordinary%20in%20school%20hallway%20bright%20colorful%20manga-inspired%20style%20playful%20atmosphere&width=800&height=400&seq=comic-07-banner&orientation=landscape',
    chapters: 420,
    status: '连载中',
    rating: 9.1,
    views: '6.8亿',
    tags: ['搞笑', '校园', '双面', '社会'],
    featured: false,
  },
  {
    id: 8,
    title: '恋爱革命',
    slug: 'love-revolution',
    category: 'romance',
    author: '232',
    description: '忠犬系男主对高冷校花一见钟情后，展开的一系列笨拙又真诚的追求故事。',
    longDescription: '孔柱英是一个单纯又执着的男高中生，当他第一次见到转学生王子琳时，就对她一见钟情了。尽管王子琳一开始对他冷漠以对，但孔柱英毫不气馁，用最笨拙又最真诚的方式努力接近她。在这个过程中，两人的关系从陌生到熟悉，从误会到理解，展开了一场青春洋溢的恋爱革命。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20high%20school%20couple%20shyly%20looking%20at%20each%20other%20cherry%20blossoms%20blooming%20spring%20day%20school%20rooftop%20setting%20warm%20sunlight%20soft%20pink%20and%20white%20tones%20romantic%20manga%20aesthetic&width=800&height=900&seq=comic-08-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20high%20school%20couple%20shyly%20looking%20at%20each%20other%20cherry%20blossoms%20blooming%20spring%20day%20school%20rooftop%20setting%20warm%20sunlight%20soft%20pink%20and%20white%20tones%20romantic%20manga%20aesthetic&width=800&height=400&seq=comic-08-banner&orientation=landscape',
    chapters: 380,
    status: '已完结',
    rating: 9.3,
    views: '5.5亿',
    tags: ['校园', '恋爱', '忠犬', '甜宠'],
    featured: false,
  },
  {
    id: 9,
    title: '全知读者视角',
    slug: 'omniscient-reader',
    category: 'fantasy',
    author: 'Sing Shong',
    description: '唯一读完那部末日小说的人，在小说世界成真的那一刻，开始了他的生存之旅。',
    longDescription: '金独子是一名普通的上班族，十年来他唯一的爱好就是追读那部连载了3149话的末世幻想小说。就在小说完结的那一天，小说中的世界竟然变成了现实。作为唯一一个知道整个故事走向的人，金独子利用自己的"全知视角"，在这个末日世界中展开了一场惊心动魄的生存冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20man%20in%20modern%20Seoul%20surrounded%20by%20apocalyptic%20fantasy%20elements%20monsters%20emerging%20from%20portals%20dimensional%20rifts%20sci-fi%20fantasy%20blend%20dramatic%20composition%20cool%20teal%20and%20dark%20tones%20cinematic%20illustration%20style&width=800&height=900&seq=comic-09-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=A%20man%20in%20modern%20Seoul%20surrounded%20by%20apocalyptic%20fantasy%20elements%20monsters%20emerging%20from%20portals%20dimensional%20rifts%20sci-fi%20fantasy%20blend%20dramatic%20composition%20cool%20teal%20and%20dark%20tones%20cinematic%20illustration%20style&width=800&height=400&seq=comic-09-banner&orientation=landscape',
    chapters: 210,
    status: '连载中',
    rating: 9.7,
    views: '4.9亿',
    tags: ['末世', '穿越', '系统', '奇幻'],
    featured: false,
  },
  {
    id: 10,
    title: '配角自救指南',
    slug: 'side-character-guide',
    category: 'fantasy',
    author: 'Haejin',
    description: '穿越成小说中注定悲惨结局的配角，为了活命必须改写命运的宫廷生存记。',
    longDescription: '女主角意外穿越成为了一部宫廷小说中的配角——一个注定在第五章就死去的炮灰。为了活下来，她必须想尽一切办法避开原著中的死亡剧情。在这个过程中，她发现了许多原著中没有描写的秘密，也逐渐改变了身边所有人的命运轨迹，从一个小配角蜕变成了故事中不可或缺的关键人物。',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20traditional%20Korean%20hanbok%20style%20dress%20standing%20in%20ancient%20palace%20courtyard%20determined%20expression%20soft%20golden%20lighting%20detailed%20historical%20fantasy%20setting%20warm%20amber%20tones&width=800&height=900&seq=comic-10-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20traditional%20Korean%20hanbok%20style%20dress%20standing%20in%20ancient%20palace%20courtyard%20determined%20expression%20soft%20golden%20lighting%20detailed%20historical%20fantasy%20setting%20warm%20amber%20tones&width=800&height=400&seq=comic-10-banner&orientation=landscape',
    chapters: 156,
    status: '连载中',
    rating: 9.0,
    views: '2.8亿',
    tags: ['穿越', '宫廷', '逆袭', '女强'],
    featured: false,
  },
  {
    id: 11,
    title: '丧尸校园',
    slug: 'zombie-campus',
    category: 'thriller',
    author: 'Joo Donggeun',
    description: '校园突然爆发丧尸病毒，被困的学生们为了生存而展开的血腥逃生之旅。',
    longDescription: '一个普通的上午，某高中校园内突然爆发了不明病毒，被感染的学生和老师变成了嗜血的丧尸。主角和一群幸存的同学们被困在教学楼中，他们必须在资源有限、信息隔绝的情况下，想尽办法逃离这个已经变成地狱的校园，同时还要面对人性的考验和生死抉择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20deserted%20Korean%20high%20school%20hallway%20with%20emergency%20lights%20flickering%20shadows%20of%20zombie%20figures%20in%20distance%20tense%20thriller%20atmosphere%20desaturated%20colors%20green%20emergency%20lighting%20cinematic%20horror%20style&width=800&height=900&seq=comic-11-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20deserted%20Korean%20high%20school%20hallway%20with%20emergency%20lights%20flickering%20shadows%20of%20zombie%20figures%20in%20distance%20tense%20thriller%20atmosphere%20desaturated%20colors%20green%20emergency%20lighting%20cinematic%20horror%20style&width=800&height=400&seq=comic-11-banner&orientation=landscape',
    chapters: 133,
    status: '已完结',
    rating: 9.1,
    views: '3.7亿',
    tags: ['丧尸', '校园', '生存', '惊悚'],
    featured: false,
  },
  {
    id: 12,
    title: '他人即地狱',
    slug: 'strangers-from-hell',
    category: 'thriller',
    author: 'Kim Yongki',
    description: '搬进便宜考试院的年轻人，发现邻居们一个比一个诡异的心理惊悚故事。',
    longDescription: '从乡下来到首尔的尹钟宇，住进了一间价格极其便宜的考试院。然而他很快发现，这个考试院里的其他房客们行为举止越来越诡异——有整天发出奇怪笑声的双胞胎，有永远板着脸的神秘大叔，还有一些行为古怪到令人毛骨悚然的人。随着调查深入，他发现了一个比想象中更加恐怖的真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=Creepy%20narrow%20hallway%20in%20old%20Korean%20goshiwon%20with%20dim%20flickering%20light%20multiple%20doors%20slightly%20ajar%20watching%20eyes%20in%20darkness%20psychological%20horror%20atmosphere%20muted%20dark%20tones%20claustrophobic%20composition&width=800&height=900&seq=comic-12-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Creepy%20narrow%20hallway%20in%20old%20Korean%20goshiwon%20with%20dim%20flickering%20light%20multiple%20doors%20slightly%20ajar%20watching%20eyes%20in%20darkness%20psychological%20horror%20atmosphere%20muted%20dark%20tones%20claustrophobic%20composition&width=800&height=400&seq=comic-12-banner&orientation=landscape',
    chapters: 115,
    status: '已完结',
    rating: 9.4,
    views: '4.2亿',
    tags: ['心理', '惊悚', '悬疑', '社会'],
    featured: false,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024年最值得追的韩漫推荐：这10部神作不容错过',
    slug: 'top-10-korean-webtoons-2024',
    excerpt: '盘点2024年最热门的韩国漫画，从热血战斗到甜宠恋爱，每一部都是精心挑选的神作级别。',
    content: '韩国漫画凭借其独特的叙事风格和精美的画风，在全球范围内收获了海量粉丝。2024年更是涌现出了许多优质作品，今天就为大家盘点最值得追的10部神作。《我独自升级》无疑是近年来最火热的韩漫之一，它不仅拥有震撼的战斗场面，主角的成长轨迹更是让人欲罢不能。从一个被嘲笑的最弱E级猎人，到能够独自对抗S级怪物的存在，这种逆袭的快感是读者们最爱的元素。《女神降临》则代表了韩漫在恋爱题材上的顶尖水准。细腻的心理描写、唯美的画风、以及令人心动的三角恋情节，让这部作品成为了恋爱类韩漫的标杆。如果你喜欢宫廷奇幻题材，那么《某天成为公主》绝对不容错过。女主穿书自救的设定新颖有趣，而冷血父皇逐渐被女儿融化的过程更是治愈了无数读者。对于追求深度剧情的读者，《奶酪陷阱》是必看之作。它不仅仅是一部恋爱漫画，更是对现代人际关系的深刻思考，刘正这个角色更是韩漫史上最具争议也最有魅力的角色之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20Korean%20webtoon%20covers%20arranged%20in%20artistic%20grid%20layout%20vibrant%20colors%20diverse%20genres%20represented%20modern%20digital%20illustration%20style%20clean%20white%20background%20editorial%20design&width=720&height=450&seq=article-01-cover&orientation=landscape',
    category: '推荐',
    date: '2024-06-15',
    author: '韩漫编辑组',
    tags: ['推荐', '盘点', '热门'],
  },
  {
    id: 2,
    title: '韩漫入门指南：从零开始的韩漫阅读之旅',
    slug: 'korean-webtoon-beginners-guide',
    excerpt: '刚接触韩漫不知道从哪里开始？这份入门指南帮你快速了解韩漫的世界，找到适合你的第一部作品。',
    content: '韩漫与日本漫画有着明显的风格差异，最显著的特点是全彩绘制和纵向滚动阅读模式，这使得阅读体验更加流畅自然。对于初次接触韩漫的读者，建议从以下几个方向开始：如果你喜欢少年热血向作品，首推《我独自升级》。这部作品完美展示了韩漫在战斗场面上的优势——全彩的画面让每一个技能特效都炫酷至极，纵向滚动的方式更是增强了战斗的节奏感。偏好恋爱题材的话，《女神降临》和《恋爱革命》是两部风格不同的代表作。前者偏向现实与心理描写，后者则更加轻松幽默。两部作品都展现了韩漫在情感刻画上的细腻程度。对于喜欢新颖设定的读者，《全知读者视角》和《某天成为公主》这两部穿越题材的作品会让你眼前一亮。韩国创作者在"穿书""系统"等设定上的创新可以说是独树一帜。值得一提的是，韩漫的更新频率普遍较高，大多数周更作品都能保证每周一话的更新节奏，而且每话的篇幅也相当充实，这意味着读者可以持续获得新鲜的内容体验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20tablet%20displaying%20colorful%20Korean%20webtoon%20warm%20ambient%20lighting%20cup%20of%20coffee%20beside%20it%20comfortable%20modern%20interior%20soft%20inviting%20atmosphere%20lifestyle%20photography&width=720&height=450&seq=article-02-cover&orientation=landscape',
    category: '指南',
    date: '2024-05-28',
    author: '韩漫编辑组',
    tags: ['入门', '指南', '科普'],
  },
  {
    id: 3,
    title: '为什么韩漫能够风靡全球？深度解析韩漫的独特魅力',
    slug: 'why-korean-webtoons-popular',
    excerpt: '从画风到叙事，从平台到商业模式，全方位解析韩漫为何能在短短几年内征服全球读者。',
    content: '韩国漫画的全球崛起绝非偶然，而是多方面因素共同作用的结果。首先是技术层面的创新。韩漫摒弃了传统的纸质分页模式，转而采用适配手机屏幕的纵向滚动条漫格式。这种"Webtoon"格式让读者只需向下滑动即可流畅阅读，大大降低了阅读门槛。同时全彩绘制让画面更具视觉冲击力，在手机屏幕上效果尤为出色。其次是内容创作的多元化。韩国漫画几乎涵盖了所有类型——从热血的《我独自升级》到甜宠的《女神降临》，从烧脑的《他人即地狱》到搞笑的《看脸时代》。这种类型的丰富性满足了不同读者的需求，每个人都有机会找到自己喜欢的作品。第三是平台生态的成熟。韩国拥有成熟的网络漫画平台体系，为创作者提供了良好的创作环境和收益模式。同时这些平台积极拓展海外市场，通过多语言翻译让全球读者都能接触到优质韩漫。最后不得不提的是韩国创作者勇于探索的精神。无论是穿书、重生、系统、还是外貌互换等新颖设定，韩国创作者总能给读者带来惊喜，这种创新能力是韩漫持续发展的核心动力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20showing%20globe%20connected%20by%20flowing%20colorful%20comic%20panels%20representing%20Korean%20webtoon%20global%20influence%20modern%20creative%20design%20vibrant%20colors%20abstract%20artistic%20concept&width=720&height=450&seq=article-03-cover&orientation=landscape',
    category: '深度',
    date: '2024-05-10',
    author: '韩漫编辑组',
    tags: ['分析', '趋势', '文化'],
  },
];

export const faqs = [
  {
    question: '韩国漫画网的漫画都是免费的吗？',
    answer: '韩国漫画网作为资源导航站，为您汇集了各大免费韩漫平台的入口链接，您可以通过我们的导航快速找到免费的韩漫资源进行在线阅读。我们致力于简化寻找优质韩漫内容的过程，让您轻松享受阅读乐趣。',
  },
  {
    question: '如何找到最新更新的韩漫？',
    answer: '您可以通过首页的"热门排行"和"最新推荐"区域查看最新更新的热门韩漫。此外，分类页面也提供了按类型筛选的功能，方便您快速定位感兴趣的漫画类别中最新更新的作品。',
  },
  {
    question: '韩漫在线阅读需要注册账号吗？',
    answer: '作为资源导航平台，韩国漫画网本身无需注册即可使用。我们提供的漫画链接将引导您至各大韩漫平台，不同平台的账号要求可能有所不同，请您根据目标平台的具体规则进行操作。',
  },
  {
    question: '网站上的漫画可以下载到手机上看吗？',
    answer: '韩国漫画网是一个导航性质的网站，提供的是各韩漫平台的访问链接。关于漫画下载功能，请参考您实际阅读的韩漫平台的相关政策。大多数正规平台支持缓存功能以便离线阅读。',
  },
  {
    question: '推荐的韩漫多久更新一次？',
    answer: '韩漫的更新频率因作品而异，大多数热门连载作品保持每周一更的节奏。首页推荐区的作品会定期更新，确保您能发现最新最热的韩漫内容。',
  },
];